import clsx from "clsx";

import { IPaymentProfile } from "models/HaulPay";
import styles from "./style.module.scss";

type PaymentProfileProps = {
  payment_profile: IPaymentProfile;
  selectPaymentProfile: VoidFunction;
};

const STATUS_COLOR_MAP: Record<string, string> = {
  approved: "text-success",
  needs_review: "text-warning",
  pending: "text-warning",
  declined: "text-error"
};

export default function PaymentProfile({
  payment_profile,
  selectPaymentProfile
}: Readonly<PaymentProfileProps>) {
  const ownerName = `${payment_profile.owner_name_first ?? ""} ${
    payment_profile.owner_name_last ?? ""
  }`.trim();
  const statusColor = STATUS_COLOR_MAP[payment_profile.status ?? ""] ?? "text-text";
  const connectionLabel = payment_profile.is_connected ? "Connected" : "Not Connected";
  const connectionColor = payment_profile.is_connected ? "text-success" : "text-subtitle";

  return (
    <button
      key={payment_profile.id}
      type="button"
      onClick={selectPaymentProfile}
      className={clsx(styles.paymentProfileWrapper, "company-btn")}>
      <div className={styles.headerRow}>
        <span className={styles.companyName}>{payment_profile.company_name}</span>
        <span className={styles.statusBadges}>
          {payment_profile.status && (
            <>
              <span className={clsx(styles.badge, statusColor, "uppercase")}>
                {payment_profile.status.replace(/_/g, " ")}
              </span>
              <span className={styles.badgeDivider}>·</span>
            </>
          )}
          <span className={clsx(styles.badge, connectionColor)}>{connectionLabel}</span>
        </span>
      </div>

      <div className={styles.metaRow}>
        {payment_profile.company_mc && <span>MC# {payment_profile.company_mc}</span>}
        {payment_profile.company_mc && payment_profile.company_dot && (
          <span className={styles.dot}>·</span>
        )}
        {payment_profile.company_dot && <span>DOT# {payment_profile.company_dot}</span>}
      </div>

      {(ownerName || payment_profile.owner_email) && (
        <div className={styles.ownerRow}>
          {ownerName && <span>{ownerName}</span>}
          {ownerName && payment_profile.owner_email && <span className={styles.dot}>·</span>}
          {payment_profile.owner_email && (
            <span className={styles.ownerEmail}>{payment_profile.owner_email}</span>
          )}
        </div>
      )}

      {payment_profile.authority === "BROKER_AUTH" && (
        <div className={styles.warning}>Co-Broker Agreement Required</div>
      )}
    </button>
  );
}
